import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./styles/index.scss";
import Navbar from "./components/Navbar/Navbar";
import AppRoutes from "./routes/routes";
import Footer from "./components/Footer/Footer";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
      <AppRoutes />
      </main>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
